'use strict';

function CompanyQueriesService(
  $stateParams,
  CompanyPublicationService,
  CompanyUserService) {
  return {
    queryPublications: function(text, publications) {
      var filter = {
        companyId: $stateParams.companyId,
        q:         text,
        limit:     10
      };

      return CompanyPublicationService.query(filter).$promise.then(function(p) {
        return p.filter(function(p) {
          return !publications.some(function(publication) {
            return publication.id === p.id;
          });
        });
      });
    },
    queryUsers: function(text, members) {
      return CompanyUserService.query({
        companyId: $stateParams.companyId,
        q: text,
        limit: 10
      }).$promise.then(function(u){
        return u.filter(function(u){
          return !members.some(function(member){
            return member.id === u.id;
          });
        });
      });
    }
  };
}

angular.module('dokiv')
  .factory('CompanyQueriesService', [
    '$stateParams',
    'CompanyPublicationService',
    'CompanyUserService',
    CompanyQueriesService
  ]);





//////////////////
// WEBPACK FOOTER
// ./scripts/company/CompanyQueriesService.js
// module id = 314
// module chunks = 0